export default __webpack_public_path__ + "static/media/olena.040b5fb3.jpg";